"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUESTION_TYPES_LIST = exports.MAXIMUM_RATING_SCALE_ITEMS = exports.KNOCKOUT_TEXT = exports.EDIT_DRAWER = exports.DEFAULT_PAGE_ID_KEY = exports.CONDITIONAL_OPERATORS = exports.CONDITIONAL_CONJUNCTIONS = exports.BUILDER_TYPE = void 0;
var _questionBuilder = require("@pcty/question-builder");
var BUILDER_TYPE = exports.BUILDER_TYPE = {
  survey: 'survey',
  quiz: 'quiz'
};
var KNOCKOUT_TEXT = exports.KNOCKOUT_TEXT = {
  survey: 'Knockout Question',
  quiz: 'Auto-Fail Question'
};
var EDIT_DRAWER = exports.EDIT_DRAWER = {
  bannerText: {
    survey: undefined,
    quiz: 'If your question is set to auto-fail mode, the quiz will be failed automatically if the learner answers incorrectly. The learner must answer an auto-fail question correctly to pass.'
  },
  inputText: {
    survey: undefined,
    quiz: 'This is an auto-fail question.'
  },
  conditionalText: {
    survey: 'If this item has conditions, it will only be displayed if those conditions are met.',
    quiz: undefined,
    noQuestions: 'Conditional display is not available until at least one choice-type question is present (Multiple Choice, Dropdown, Star Rating, or Rating Scale).'
  }
};
var QUESTION_TYPES_LIST = exports.QUESTION_TYPES_LIST = [{
  type: 'multipleChoice',
  label: 'Multiple Choice',
  questionTypeId: _questionBuilder.QUESTION_TYPE.multipleChoice
}, {
  type: 'multipleChoice',
  label: 'Multiple Choice (Checkboxes)',
  questionTypeId: _questionBuilder.QUESTION_TYPE.checkbox
}, {
  type: 'stackRank',
  label: 'Stack Rank',
  questionTypeId: _questionBuilder.QUESTION_TYPE.stackRank
}, {
  type: 'trueFalse',
  label: 'True / False',
  questionTypeId: _questionBuilder.QUESTION_TYPE.trueFalse
}, {
  type: 'title',
  label: 'Section Divider',
  questionTypeId: _questionBuilder.QUESTION_TYPE.title
}, {
  type: 'paragraph',
  label: 'Paragraph',
  questionTypeId: _questionBuilder.QUESTION_TYPE.paragraph
}, {
  type: 'textField',
  label: 'Text Input',
  questionTypeId: _questionBuilder.QUESTION_TYPE.textField
}, {
  type: 'starRating',
  label: 'Star Rating',
  questionTypeId: _questionBuilder.QUESTION_TYPE.starRating
}, {
  type: 'ratingScale',
  label: 'Rating Scale',
  questionTypeId: _questionBuilder.QUESTION_TYPE.ratingScale
}, {
  type: 'multipleText',
  label: 'Multiple Text',
  questionTypeId: _questionBuilder.QUESTION_TYPE.multipleText
}, {
  type: 'constantSum',
  label: 'Constant Sum',
  questionTypeId: _questionBuilder.QUESTION_TYPE.constantSum
}, {
  type: 'dropdownList',
  label: 'Dropdown',
  questionTypeId: _questionBuilder.QUESTION_TYPE.dropdownList
}, {
  type: 'video',
  label: 'Video',
  questionTypeId: _questionBuilder.QUESTION_TYPE.video
}];
var CONDITIONAL_OPERATORS = exports.CONDITIONAL_OPERATORS = {
  EQUALS: '=',
  NOT_EQUALS: '<>'
};
var CONDITIONAL_CONJUNCTIONS = exports.CONDITIONAL_CONJUNCTIONS = {
  AND: 'and',
  OR: 'or'
};
var MAXIMUM_RATING_SCALE_ITEMS = exports.MAXIMUM_RATING_SCALE_ITEMS = 15;
var DEFAULT_PAGE_ID_KEY = exports.DEFAULT_PAGE_ID_KEY = 'DEFAULT_PAGE_ID_KEY';